import { useState, useEffect } from 'react'
import { ActionPlanService } from 'utility/services/action-plan'

export const useActionPlan = userId => {
    const [assignedTickets, setAssignedTickets] = useState({
        items: [],
        totalCount: 0,
    })
    const [myTickets, setMyTickets] = useState({ items: [], totalCount: 0 })
    const [ticketStatus, setTicketStatus] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const fetchAssignedTickets = async (pageNumber = 1, pageSize = 10, filters = null) => {
        try {
            setLoading(true)
            const response = await ActionPlanService.getAssignedTickets(
                userId,
                pageNumber,
                pageSize,
                filters,
            )
            setAssignedTickets({
                items: response.Items || [],
                totalCount: response.TotalCount || 0,
            })
        } catch (err) {
            setError(err.message)
            console.error('Error fetching assigned tickets:', err)
        } finally {
            setLoading(false)
        }
    }

    const fetchMyTickets = async (pageNumber = 1, pageSize = 10, filters = null) => {
        try {
            setLoading(true)
            const response = await ActionPlanService.getMyTickets(
                userId,
                pageNumber,
                pageSize,
                filters,
            )
            setMyTickets({
                items: response.Items || [],
                totalCount: response.TotalCount || 0,
            })
        } catch (err) {
            setError(err.message)
            console.error('Error fetching my tickets:', err)
        } finally {
            setLoading(false)
        }
    }

    const fetchTicketStatus = async () => {
        try {
            const response = await ActionPlanService.getTicketStatus()
            setTicketStatus(response || [])
        } catch (err) {
            console.error('Error fetching ticket status:', err)
        }
    }

    useEffect(() => {
        if (userId) {
            fetchTicketStatus()
        }
    }, [userId])

    return {
        assignedTickets,
        myTickets,
        ticketStatus,
        loading,
        error,
        fetchAssignedTickets,
        fetchMyTickets,
        fetchTicketStatus,
    }
}
